export default __webpack_public_path__ + "static/media/profile.bb3a81d4.jpg";